import React from 'react'

interface FormFieldProps {
    name: string
    placeholder: string
    type?: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur: () => void
    error?: string
    component?: string
    hubspotField?: string
    options?: Array<{
        value: string
        label: string
    }>
}

interface FormInputProps {
    name: string
    placeholder: string
    type?: string
    value: string
    onChange: (e: React.ChangeEvent<any>) => void
    onBlur: (e: React.FocusEvent<any>) => void
    error?: string
    component?: string
    hubspotField?: string
    options?: Array<{
        value?: string
        hubspotValue: string | number
        label?: string
    }>
    optional?: boolean
}

export const FormInput: React.FC<FormInputProps> = ({
    name,
    placeholder,
    type = 'text',
    value,
    onChange,
    onBlur,
    error,
    component,
    options,
    optional,
}) => {
    const inputClasses = `w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
        error ? 'border-red-500' : 'border-gray-300'
    }`

    const getPlaceholder = () => {
        return optional ? placeholder : `${placeholder} *`
    }

    if (component === 'TextArea') {
        return (
            <div>
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={`${inputClasses} min-h-[100px]`}
                    placeholder={getPlaceholder()}
                />
                {error && <p className="text-red-500 mt-1 text-sm">{error}</p>}
            </div>
        )
    }

    if (component === 'Select' && options) {
        return (
            <div>
                <select
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={inputClasses}
                >
                    <option value="">{getPlaceholder()}</option>
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label || option.value}
                        </option>
                    ))}
                </select>
                {error && <p className="text-red-500 mt-1 text-sm">{error}</p>}
            </div>
        )
    }

    return (
        <div>
            <input
                id={name}
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className={inputClasses}
                placeholder={getPlaceholder()}
            />
            {error && <p className="text-red-500 mt-1 text-sm">{error}</p>}
        </div>
    )
}

export function FormTextArea({ name, placeholder, value, onChange, onBlur, error }: FormFieldProps) {
    return (
        <div className="relative">
            <label className="block w-full" htmlFor={name}>
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange as any}
                    onBlur={onBlur}
                    className={`
            w-full rounded-lg bg-[#1B3154] px-4 py-3 text-white
            placeholder:text-white/50
            focus:outline-none focus:ring-2 focus:ring-[#4BB3FD]/50
            ${error ? 'border-red-500' : 'border-transparent'}
            min-h-[100px] resize-y
          `}
                    placeholder={placeholder}
                />
            </label>
            {error && <p className="text-red-500 absolute -bottom-5 left-0 text-sm">{error}</p>}
        </div>
    )
}
